moduleEditorDirectives = angular.module('directives.htmlcompiler', [])

moduleEditorDirectives.directive 'ngHtmlCompile', ["$compile", "$timeout", ($compile, $timeout) ->
  restrict: 'A'
  link: (scope, element, attrs) ->
    scope.$watchCollection attrs.ngHtmlCompile, (newValue, oldValue) ->
      element.html newValue
      $compile(element.contents()) scope
      return
    return
]



// WEBPACK FOOTER //
// ./src/app/editor/components/common/htmlcompiler.directive.coffee